export default __webpack_public_path__ + "static/media/search.ce43fea4.svg";